export function fetchSelectedCustomerGoogleAdsData(URL, access_token, customer_id) {
    console.log("access_token", access_token)
    return new Promise(async (resolve, reject) => {
      try {
          const response = await fetch(URL,{
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${access_token}`,
              },
              body: JSON.stringify({ customer_id })  // Serialize customer_id to JSON
          });
          const result = await response.json();
          resolve(result)
      } catch (error) {
        reject(error);
      }
    });
}
